import { render, staticRenderFns } from "./ImageSectionMijnTarievenText.vue?vue&type=template&id=044eae5a&"
import script from "./ImageSectionMijnTarievenText.vue?vue&type=script&lang=js&"
export * from "./ImageSectionMijnTarievenText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports